import { createSlice } from "@reduxjs/toolkit";

const CategorySlice = createSlice({
  name: "category",
  initialState: {
    value: [],
  },
  reducers: {
    UpdateValue(state, { payload }) {
      state.value = payload;
    },
    UpdateRow(state, { payload }) {
      state.value.forEach((item) => {
        if (item.id === payload.id) {
          Object.assign(item, payload);
        }
      });
    },
    DeleteRow(state, { payload }) {
      state.value = state.value.filter((item) => item.id !== payload.id);
    },
    CreateCategory(state, { payload }) {
      state.value.unshift(payload);
    },
  },
});

export const selectAll = (state) => state.category.value;
export const { DeleteRow, UpdateRow, CreateCategory, UpdateValue } =
  CategorySlice.actions;
export default CategorySlice.reducer;
